module.exports = __webpack_public_path__ + "img/renewmain.e8fcde5c.jpg";